// src/pages/Home.jsx

import React from "react";
import "./Home.css";

import { Link } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";
import { FaCalendarCheck } from "react-icons/fa6";
import { IoCall } from "react-icons/io5";
import TypingText from "../TypingText/TypingText";
import vtcImage from '../../components/Home/vtc.png';
const Home = () => {
  return (
    <div className="home-container">
      <div className="hero-section" style={{ backgroundImage: `url(${vtcImage})` }}>
     
        <div className="overlay">
          <a
            className="btn  custom-call-btn   bg-dark rounded-pill fw-bold"
            href="tel:+33661585885"
              aria-label="Call Revierradriver at +33 6 15 85 88 5"
              id="call-button"
          >
            <IoCall
              className="text-warning"
              style={{ fontSize: "1.3rem", marginRight: "10px" }}
            />
            <span className="text-light fw-bold"> (33)661585885</span>
          </a>

          <h1 className="titles">Bienvenue chez Revierradriver</h1>
          <div style={{ fontSize: "2rem", fontWeight: "bold", color: "#333" }}>
            <TypingText
              className="typingtext"
              words={[
                "Nice",
                "Cannes",
                "Saint Laurent du Var",
                "Beausoleil",
                "Antibes",
                "La Turbie",
                "Villefranche-sur-Mer",
                "Saint-Jean-Cap-Ferrat",
                "St Tropez",
                "Grimaud",
                "Cogolin",
                "Cap d’Ail",
                "Beaulieu-sur-Mer",
                "Ramatuelle",
                "Gassin",
                "Le Cannet",
                "Villeneuve-Loubet",
                "Èze",
                "Carros",
                "Cagnes-sur-Mer",
                "Vence",
              ]}
            />
          </div>
          <p className="subtitle text-light fw-bold">
            Voitures de luxe, service professionnel
          </p>
          <Link to="bookingForm" className="cta-button text-decoration-none">
            Réserver maintenant
          </Link>
        </div>

        <li className="tag__item">
          <a
            href="https://wa.me/33661585885?text=Hello%20I%20would%20like%20to%20make%20a%20reservation"
            target="_blank"
            rel="noopener noreferrer"
            className="floating-button whatsapp-button"
          >
            <FaWhatsapp />
          </a>
        </li>


        <li className="tag__item">
          <Link
            to="/bookingForm"
            target="_blank"
            rel="noopener noreferrer"
            className="floating-button booking-button"
          >
            <FaCalendarCheck />
          </Link>
        </li>

      
      </div>
    </div>
  );
};

export default Home;
